// extracted by css-extract-rspack-plugin
export default {"danger":"ttiUbbxwqmsw7QOq","success":"pbVnj593cWcZKK7s","warning":"vVt1L_iy0wN1RIJy"};